var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"安全区查看","loading":_vm.loading}},[(!_vm.loading)?[_c('div',{ref:"blockRef",class:_vm._.block},[_c('div',{class:_vm._.box})]),_c('hr'),_c('pre',{class:_vm._.info},[_vm._v(_vm._s(_vm.safe))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }